export const notificationTextStyle = {
  fontSize: 12,
  lineHeight: '14px',
};
